import _ from 'lodash';

import { RouteComponentProps } from 'react-router-dom';
import { Typography } from 'omakase';
import { parse, stringify } from '@tock/query-string';
import Anchor from 'components/Anchor';
import SecondaryHeader from 'components/header/SecondaryHeader';

interface Props {
  location: RouteComponentProps['location'];
}

export default (props: Props) => {
  const { pathname, search } = props.location;
  const { previewMode, endDate, ...rest } = parse(search);
  const href = `${pathname}${_.isEmpty(rest) ? '' : `?${stringify(rest)}`}`;
  return (
    <SecondaryHeader variant="warning" align="center">
      <Typography color="inherit" component="span" variant="body02">
        You are previewing this page.&nbsp;
        <Anchor href={href} reload>
          View as guest
        </Anchor>
      </Typography>
    </SecondaryHeader>
  );
};
